import { createDraftSafeSelector } from '@reduxjs/toolkit';

const selectSelf = (state: RootState) => state.attachments;

const attachmentSelector = createDraftSafeSelector(selectSelf, (state) => state.attachment);

const auctionAttachmentsSelector = createDraftSafeSelector(attachmentSelector, (attachment) => {
  const { attachments: cachedAttachments, isShow, type, selectedAttachment } = attachment;

  if (!cachedAttachments || cachedAttachments === null || !type) {
    return {
      isShow: false,
      attachments: null,
    };
  }

  if (type === 'certificates') {
    return {
      isShow,
      attachments: cachedAttachments[type],
    };
  }

  const attachments = [...cachedAttachments['images'], ...cachedAttachments['video360']];

  return {
    isShow,
    selectedAttachment: type === 'video360' ? attachments.length - 1 : selectedAttachment ?? 0,
    attachments,
  };
});

export const attachmentsSelectors = {
  auctionAttachmentsSelector,
};
